import { createReducer, on } from '@ngrx/store';
import { initialState } from 'app/trello/store/board-summary-report/board-summary-report.state';
import {
  loadBoardSummaryStatistics,
  loadBoardSummaryStatisticsFailure,
  loadBoardSummaryStatisticsSuccess,
  loadComparableBoardSummaryStatistics,
  loadComparableBoardSummaryStatisticsFailure,
  loadComparableBoardSummaryStatisticsSuccess,
  loadLabels,
  loadLabelsFailure,
  loadLabelsSuccess,
  loadLists,
  loadListsFailure,
  loadListsSuccess,
  loadMembers,
  loadMembersFailure,
  loadMembersSuccess
} from './board-summary-report.actions';

export const boardSummaryReportReducer = createReducer(
  // ------------------------------------------------------

  initialState,

  // ------------------------------------------------------

  on(loadBoardSummaryStatistics, state => ({
    ...state,
    boardSummary: {
      ...state.boardSummary,
      loading: true,
      error: null,
    },
  })),

  on(loadBoardSummaryStatisticsSuccess, (state, {boardSummary, dateRange}) => ({
    ...state,
    boardSummary: {
      data: boardSummary,
      dateRange,
      loading: false,
      loaded: true,
      error: null,
    }
  })),

  on(loadBoardSummaryStatisticsFailure, (state, {error}) => ({
    ...state,
    boardSummary: {
      ...state.boardSummary,
      loading: false,
      error,
    }
  })),

  // ------------------------------------------------------

  on(loadComparableBoardSummaryStatistics, state => ({
    ...state,
    comparableBoardSummary: {
      ...state.comparableBoardSummary,
      loading: true,
      error: null,
    }
  })),

  on(loadComparableBoardSummaryStatisticsSuccess, (state, {comparableBoardSummary, comparableDateRange}) => ({
    ...state,
    comparableBoardSummary: {
      data: comparableBoardSummary,
      dateRange: comparableDateRange,
      loading: false,
      loaded: true,
      error: null,
    }
  })),

  on(loadComparableBoardSummaryStatisticsFailure, (state, {error}) => ({
    ...state,
    comparableBoardSummary: {
      ...state.comparableBoardSummary,
      loading: false,
      error,
    }
  })),

  // ------------------------------------------------------

  on(loadLabels, state => ({
    ...state,
    labels: {
      ...state.labels,
      loading: true,
      error: null,
    },
  })),

  on(loadLabelsSuccess, (state, {labels}) => ({
    ...state,
    labels: {
      data: labels,
      loading: false,
      loaded: true,
      error: null,
    },
  })),

  on(loadLabelsFailure, (state, {error}) => ({
    ...state,
    labels: {
      ...state.labels,
      loading: false,
      error,
    },
  })),

  // ------------------------------------------------------

  on(loadLists, state => ({
    ...state,
    lists: {
      ...state.lists,
      loading: true,
      error: null,
    },
  })),

  on(loadListsSuccess, (state, {lists}) => ({
    ...state,
    lists: {
      data: lists,
      loading: false,
      loaded: true,
      error: null,
    },
  })),

  on(loadListsFailure, (state, {error}) => ({
    ...state,
    lists: {
      ...state.lists,
      loading: false,
      error,
    },
  })),

  // ------------------------------------------------------

  on(loadMembers, state => ({
    ...state,
    members: {
      ...state.members,
      loading: true,
      error: null,
    },
  })),

  on(loadMembersSuccess, (state, {members}) => ({
    ...state,
    members: {
      data: members,
      loading: false,
      loaded: true,
      error: null,
    },
  })),

  on(loadMembersFailure, (state, {error}) => ({
    ...state,
    members: {
      ...state.members,
      loading: false,
      error,
    },
  })),

  // ------------------------------------------------------

);
